import { useLazyQuery, useMutation } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import useUser from "hooks/useUser";
import LOGIN from "mutations/login";
import GET_ME from "queries/getMe";
import { useHistory } from "react-router-dom";
import Login from "./Login";
const usePrepareComponent = () => {
    const history = useHistory();
    const { onSetToken } = useUser();
    const [login, { loading }] = useMutation(LOGIN);
    const [getMe] = useLazyQuery(GET_ME);
    const onLoginCompleted = ({ login: { token } }) => {
        onSetToken(token);
        getMe({
            fetchPolicy: "network-only",
            onCompleted: () => {
                history.push("/");
            }
        });
    };
    const onSubmit = ({ password, username }) => {
        login({
            onCompleted: onLoginCompleted,
            variables: { loginInput: { password, username } }
        });
    };
    return {
        isLoading: loading,
        onSubmit
    };
};
export default prepareComponent(usePrepareComponent)(Login);
